import React from 'react';
import ReactDOM from 'react-dom';
import App from './components/App';
//import registerServiceWorker from './registerServiceWorker';

import 'bootstrap/dist/css/bootstrap.css';
import './styles/bootstrap-overrides.css';
import './styles/app.css';

ReactDOM.render(<App />, document.getElementById('root'));
//registerServiceWorker();




// WEBPACK FOOTER //
// ./src/index.js